import { render, staticRenderFns } from "./ChangeBlockCount.vue?vue&type=template&id=3d6aa4c9&scoped=true&"
import script from "./ChangeBlockCount.vue?vue&type=script&lang=js&"
export * from "./ChangeBlockCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6aa4c9",
  null
  
)

export default component.exports